export const progressionButtonStyle = {
  button: {
    minWidth: 300,
  },
};
